module.exports = __webpack_public_path__ + "static/media/planimg.9e6d599b.png";